import React from "react";
import {Button, Col, List, Popconfirm, Typography} from "antd";
import {LinkOutlined, PlusOutlined} from "@ant-design/icons";

const {Text, Title} = Typography

export class FicheLinks extends React.Component {


    render() {
        const {selected, fiche} = this.props

        if (!selected) {
            return null
        }

        if (selected.links.length === 0) {
            return null
        }

        return (
            <Col>
                <Col style={{display: "flex", justifyContent: "flex-end", marginBottom: 30}}>
                    <Button type="primary" icon={<PlusOutlined/>} onClick={() => fiche.modalAddLink.show(selected.id)}>Ajouter
                        un lien</Button>
                </Col>
                <List
                    grid={{gutter: 16, column: 2}}
                    itemLayout="horizontal"
                    dataSource={selected.links}
                    renderItem={item => (
                        <List.Item actions={[
                            <Popconfirm
                                title="Êtes-vous sûrs de vouloir supprimer ce lien ?"
                                onConfirm={() => fiche.onDelete(item.id, "link")}
                                okText="Oui"
                                cancelText="Non"
                                okType={"danger"}
                            >
                                <a href="#" onClick={() => {
                                }}>Supprimer</a>
                            </Popconfirm>
                        ]}>

                            <List.Item.Meta
                                style={{cursor: "pointer"}}
                                avatar={<LinkOutlined/>}
                                title={<a href={item.link} target={"_blank"}
                                          rel="noreferrer">{item.name}</a>}
                                description={item.link}
                            />
                        </List.Item>
                    )}
                />
            </Col>
        )
    }
}
